var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string, oneOf } from 'prop-types';
import styled from 'styled-components';
import Heading from '../heading/Heading'; // Creates a Header component based on Sharp style guidelines

var SharpCardTitle = styled(Heading).attrs(function (props) {
  return {
    color: props.color || '#827771',
    variant: props.size || 4
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n"])));
SharpCardTitle.displayName = 'Card.Title';

var CardTitle = function CardTitle(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? '#846550' : _ref$fontColor,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 4 : _ref$variant;
  return /*#__PURE__*/React.createElement(SharpCardTitle, {
    className: "scl-card-wrapper ".concat(className),
    color: fontColor,
    variant: variant
  }, children);
};

CardTitle.propTypes = {
  /**
   Required and consists of everything included between opening and closing tags of <Card.Title>
  */
  children: node.isRequired,

  /**
   Optional className to include in rendered title
  */
  className: string,

  /**
   Optional to control color of font
  */
  fontColor: string,

  /**
    Optional to control size of heading. If variant is 1, rendered Heading is an \<h1>
  */
  variant: oneOf([1, 2, 3, 4, 5, 6])
};
export default CardTitle;